import React, { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (error.message && /Loading chunk [\d]+ failed/.test(error.message)) {
      return { hasError: true, isChunkError: true };
    }
    return { hasError: true, isChunkError: false };
  }

  componentDidCatch(error, errorInfo) {
    console?.error("ErrorBoundary caught an error", error, errorInfo);
    if (error.message && /Loading chunk [\d]+ failed/.test(error.message)) {
      if (!window.reloadAttempted) {
        window.reloadAttempted = true;
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">
              <h1 className="text-2xl font-bold mb-4">New Version Available</h1>
              <p>Loading the latest version of the application...</p>
              <button 
                className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
                onClick={() => window.location.reload()}
              >
                Click here if not automatically redirected
              </button>
            </div>
          </div>
        );
      }
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;